module.exports = __webpack_public_path__ + "static/media/Food8.b8bff720.jpg";